const styles = {
    picker: {
      width: "20rem !important",
      marginTop: "2rem"
    },
    addColor: {
      width: "100%",
      padding: "1rem",
      marginTop: "1rem",
      fontSize: "2rem"
    },
    colorNameInput: {
      width: "100%",
      height: "70px"
    }
  };

  export default styles